import { Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { ActivatedRoute, Router } from '@angular/router'; 
import { OrdertemplateService } from '../../_services/ordertemplate.service';
import { ClientService } from 'app/_services/client.service';
import { TokenStorageService } from '../../_services/token-storage.service';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-edit-ordertemplate',
  templateUrl: './edit-ordertemplate.component.html'
})

export class EditOrdertemplateComponent implements OnInit, OnDestroy {
  contactUUID: string = "";
  orderId: number = 0;
  clientId: number = 0;
  clientInfo: any = [];
  contractInfo: any = [];
  orderInfo: any = {};
  orderItemsList: any = [];
  orderItemsForm: FormGroup = new FormGroup({});
  contactTypeList: any = [];
//other order details
  order_updated_date: string = "";
  order_created_date: string = "";
  created_by_name: string = "";
//order items totals
  orderInfoTotals: any = [];
  update_message: string = "";
  template_name: string = "template1";
  newId_index: number = 0;
  subscription: any;

  editOrdertemplateForm: FormGroup = new FormGroup({
    //order related
    
  })

  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private order: OrdertemplateService,
    private clients: ClientService,
    private changeDetectorRef: ChangeDetectorRef,

  ) { }


  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.orderId = this.activatedRoute.snapshot.params['orderid'];

    this.subscription = this.order.getOrdertemplate$(this.contactUUID, this.template_name ).subscribe({
      next: (data: {}) => {
        this.orderInfo['items'] = data;
        this.orderItemsList = this.orderInfo['items'];
        console.log("order after load",  this.orderItemsList);

        for(let i=0; i < this.orderItemsList.length; i++) {

          this.order_updated_date = new Date(this.orderItemsList[i].updated).toLocaleDateString("en-us");
          this.order_created_date = new Date(this.orderItemsList[i].created).toLocaleDateString("en-us");
          this.created_by_name = this.orderItemsList[i].created_by;

          console.log("date_updated", this.order_updated_date );

          this.orderItemsForm.addControl('orderitem_amount_'+i, new FormControl(""));
          this.orderItemsForm.controls['orderitem_amount_'+i].patchValue(this.orderItemsList[i].amount);

          this.orderItemsForm.addControl('orderitem_istaxable_'+i, new FormControl(""));
          this.orderItemsForm.controls['orderitem_istaxable_'+i].patchValue(this.orderItemsList[i].is_taxable);

          this.orderItemsForm.addControl('orderitem_order-count_'+i, new FormControl(""));
          this.orderItemsForm.controls['orderitem_order-count_'+i].patchValue(this.orderItemsList[i].order_count);

          this.orderItemsForm.addControl('orderitem_description_'+i, new FormControl(""));
          this.orderItemsForm.controls['orderitem_description_'+i].patchValue(this.orderItemsList[i].description);
          
          this.orderItemsForm.addControl('orderitem_cadence_'+i, new FormControl(""));
          this.orderItemsForm.controls['orderitem_cadence_'+i].patchValue(i);
         
        }

        this.changeDetectorRef.detectChanges();
      
      },
      error: (err: any) => {
        console.log("Something went wrong fetching the invoice: ", err)
      }
    });

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openCalendar(e: any): void {
    console.log(e)
  }

  lineItemID(index:number, currentOrderItem: any){

    //console.log('currentOrderItem.order_item_template_id', currentOrderItem.order_item_template_id);
    return currentOrderItem.order_item_template_id;
  }

  /*  Add an extra empty email field */
  addOrderItem(): void  {

    const arr = this.orderItemsList;
    const max = arr.reduce((p:any,v:any) => (p.order_item_template_id ) > (v.order_item_template_id) ? p.order_item_template_id : v.order_item_template_id);

    //console.log('max: ',max);
    let oldItemsLength = this.orderItemsList.length;
    console.log(' oldItemsLength: ', oldItemsLength);

    this.orderItemsForm.addControl("orderitem_amount_"+oldItemsLength, new FormControl(""));
    this.orderItemsForm.controls["orderitem_amount_"+oldItemsLength].patchValue(0);
    this.orderItemsForm.addControl("orderitem_order-count_"+oldItemsLength, new FormControl(""));
    this.orderItemsForm.controls["orderitem_order-count_"+oldItemsLength].patchValue(1);
    this.orderItemsForm.addControl("orderitem_istaxable_"+oldItemsLength, new FormControl(""));
    this.orderItemsForm.controls["orderitem_istaxable_"+oldItemsLength].patchValue(true);
    this.orderItemsForm.addControl("orderitem_description_"+oldItemsLength, new FormControl(""));
    this.orderItemsForm.controls["orderitem_description_"+oldItemsLength].patchValue('');
    this.orderItemsForm.addControl("orderitem_cadence_"+oldItemsLength, new FormControl(""));
    this.orderItemsForm.controls["orderitem_cadence_"+oldItemsLength].patchValue(oldItemsLength);


    this.orderItemsList[oldItemsLength] = {
        order_item_template_id: max+1,
        amount: 0,
        order_count: 1,
        description: 'foo',
        cadence: oldItemsLength,
        is_taxable: true,
        tax_federal: 0,
        tax_provincial: 0,
        tax_id: 1,
       
    };

    this.changeDetectorRef.detectChanges();


    console.log("list after add item",  this.orderItemsList);
    
    //console.log("myId", myId);

    //const item_i=this.orderItemsList.length-1;
   // console.log(item_i);

    //console.log("orderitem_amount", item_i + ' ');
   

  }

  removeOrderItem(index:number, fieldValue: any, itemId: number): void  {
    
    //this.hideRefresh();
    var array = this.orderItemsList;
    var key = itemId;
    console.log('key', itemId);
    let x:any;

    index = array.findIndex(function(item:any) {
      return item.order_item_template_id === key
    });

    console.log('index', index);

    let new_array: any = [];  
    let counter = 0;
    this.orderItemsList.forEach(function(arr_obj: any, key: number) {
        
        if(key != index) {
            new_array[counter] = arr_obj;
            counter ++;
        }

    },);
  
    this.orderItemsList = new_array;
    console.log("order after remove",  this.orderItemsList);

    this.orderItemsForm.removeControl("orderitem_amount_"+index);
    this.orderItemsForm.removeControl("orderitem_order-count_"+index);
    this.orderItemsForm.removeControl("orderitem_istaxable_"+index);
    this.orderItemsForm.removeControl("orderitem_description_"+index);
    this.orderItemsForm.removeControl("orderitem_cadence_"+index);


    this.changeDetectorRef.detectChanges();
  
  }

  onChangeOrderItemAmount( index:number, fieldValue: any):void {
  
    if(isNaN(fieldValue.value)){
      this.orderItemsList[index].amount = 0;
    }else{
     this.orderItemsList[index].amount =  Number(fieldValue.value);
    }

    console.log('index',index);
    console.log('to job new from', fieldValue.value);
    console.log("order after amount change",  this.orderItemsList);
  }

  onChangeOrderItemQtyOrder( index:number, fieldValue: any):void {

    if(isNaN(fieldValue.value)){
      this.orderItemsList[index].order_count = 0;
    }else{
     this.orderItemsList[index].order_count =  Number(fieldValue.value);
    }

    console.log('index',index);
    console.log('to job new from', fieldValue.value);
    console.log("order after qty change",  this.orderItemsList);
  }

  onChangeOrderItemTax( index:number, event: any):void {
    this.orderItemsList[index].is_taxable = !event.target.checked;
    console.log(' tax is ',this.orderItemsList[index].is_taxable);

    if(event.target.checked == false) {
      console.log('unchecked ============ ');
    }
   
    console.log("order after tax change",  this.orderItemsList);

  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  onSubmit(formValues: any, orderValues: any,): void {

    console.log("All values ", formValues);
    console.log("order values ", orderValues);

    var keys = Object.keys(orderValues);
    var len = keys.length;    

    console.log("length ",len);
    let orderInfos: any = [];
    let iterations = Number(Number(len) / 5);

    console.log("iter ", iterations);
    
    for(let i=0; i < iterations; i++) {

      orderInfos.push({
        "order_item_template_name": this.template_name,
        "description": orderValues['orderitem_description_'+i],
        "order_count": orderValues['orderitem_order-count_'+i],
        "amount": orderValues['orderitem_amount_'+i],
        "is_taxable": orderValues['orderitem_istaxable_'+i],
        "tax_federal": 0,
        "tax_provincial": 0,
        "tax_id": 1,
        "cadence": i
      });

    }

    console.log('items sent', orderInfos);

    this.order.modifyOrdertemplate$(this.contactUUID,  orderInfos).subscribe({
      next: (data:any) => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the order",data);
        this.orderInfo.updated = data.updated;
        //this.goToTop();
        this.refreshWin();
        console.log("order submitted",  this.orderItemsList);
      },
      error: (err: any) => {
        console.log("Something went wrong updating the order: ", err)
        console.log("oops", orderInfos);
      }
    })
    
  }

  refreshWin(): void {
    window.location.reload();
  }

  

}